export default {
  /**
   * @variable {Internet Error}
   */

  e_internet: 'Internet Error'

  /**
   * 主播offline
   * @variable {She's not available.}
   */

  ,
  e_dontDisturb: 'She\'s not available.'

  /**
   * 主播未登陆
   * @variable {She's not online.}
   */

  ,
  e_logout: 'She\'s not online.'

  /**
   * 主播忙碌
   * @variable {The host is in a video call}
   */

  ,
  e_busy: 'The host is in a video call.'

  /**
   * 强制下麦中
   * @variable {Please don't do anything inappropriate again.Try again in 5 minutes.}
   */

  ,
  e_force_down_mic: 'Please don\'t do anything inappropriate again.Try again in 5 minutes.'

  /**
   * 被禁止文字消息
   * @variable {You have been banned by admin.}
   */

  ,
  e_banned: 'You have been banned by admin.'

  /**
   * 已经有boss了
   * @variable {We have a boss now, please try again later!}
   */

  ,
  e_has_boss: 'We have a boss now, please try again later!'

  /**
   * 主播已经没在麦位上了
   * @variable {She is not in the party now, please wait her back or support other girls.}
   */

  ,
  e_anchor_not_in_mic: 'She is not in the party now, please wait her back or support other girls.'

  /**
   * svip充值成功
   * @variable {Congrats! You've being SVIP now.}
   */

  ,
  svp_success: 'Congrats! You\'ve being SVIP now.'

  /**
   * 金币购买成功
   * @variable {Congrats! You have got %d coins.}
   */

  ,
  buy_coin_success: 'Congrats! You have got %d coins.'

  /**
   * @variable {Server error}
   */

  ,
  e_server: 'Server error'

  /**
   * 被房主踢下boss
   * @variable {You've been kicked by the host.}
   */

  ,
  been_kick: 'You\'ve been kicked by the host.'

  /**
   * 被房主关麦
   * @variable {You've been silenced by the host.}
   */

  ,
  been_mute: 'You\'ve been silenced by the host.'

  /**
   * 被房主解禁
   * @variable {The host cancels the mute to you.}
   */

  ,
  cancel_mute: 'The host cancels the mute to you.'

  /**
   * 房间关闭
   * @variable {Live room has been closed!}
   */

  ,
  room_close: 'Live room has been closed!',

  mb_room_close: 'MultiBeam room has been closed!'

  /**
   * 不能发送空消息
   * @variable {Can't send blank message.}
   */

  ,
  e_send_blank_msg: 'Can\'t send blank message.'

  /**
   * 电话被拒接
   * @variable {Call Refused!}
   */

  ,
  call_refused: 'Call Refused!'

  /**
   * 对方挂断
   * @variable {The other party has hung up.}
   */

  ,
  other_hung_up: 'The other party has hung up.'

  /**
   * 对方挂断
   * @variable {0 and 1 are system fields that cannot be sent individually}
   */

  ,
  pricha_error_system_msg: '0 and 1 are system fields that cannot be sent individually'

  /**
   * @variable {Automatic exit after evaluation}
   */

  ,
  eva_finish: 'Automatic exit after evaluation'

  /**
   * @variable {This call will end in 120 seconds Please recharge as early as you can.}
   */

  ,
  hunt_remind_recharge: 'This call will end in 120 seconds Please recharge as early as you can.'

  /**
   * @variable {You don't have enough coins, please recharge first.}
   */

  ,
  remind_recharge: 'You don\'t have enough coins, please recharge first.'

  /**
   * @variable {We’re an one on one video live chat app so all your calls will be private.}
   */

  ,
  call_tip: 'We’re an one on one video live chat app so all your calls will be private.'

  /**
   * @variable {20 coins/min after %d minutes for free}
   */

  ,
  take_call_tip: '20 coins/min after %d minutes for free'

  /**
   * @variable {Hang up the phone.}
   */

  ,
  hungup0: 'Hang up the phone.'

  /**
   * @variable {You have hung up.}
   */

  ,
  hungup1: 'You have hung up.'

  /**
   * @variable {The host has hung up.}
   */

  ,
  hungup2: 'The host has hung up.'

  /**
   * @variable {You have run out of the coins.}
   */

  ,
  hungup3: 'You have run out of the coins.'

  /**
   * @variable {You have lost Internet connection.}
   */

  ,
  hungup4: 'You have lost Internet connection.'

  /**
   * @variable {The host has lost Internet connection.}
   */

  ,
  hungup5: 'The host has lost Internet connection.'

  /**
   * @variable {Are you sure to hang up this call?}
   */

  ,
  hungupConf: 'Are you sure to hang up this call?'

  /**
   * @variable {How do you feel about this call?}
   */

  ,
  pricha_end_feel: 'How do you feel about this call?'

  /**
   * @variable {Go private with her and she will be all yours}
   */

  ,
  lime_pricha_desc: 'Go private with her and she will be all yours'

  /**
   * @variable { for 3+ minutes free }
   */

  ,
  multi_take_price: ' for 3+ minutes free '

  /**
   * @variable { for 3+ minutes free private video show}
   */

  ,
  pvs: ' for 3+ minutes free private video show'

  /**
   * @variable {Pretty Face}
   */

  ,
  good_t_1: 'Pretty Face'

  /**
   * @variable {Good Attitude/Behaviors}
   */

  ,
  good_t_2: 'Good Attitude/Behaviors'

  /**
   * @variable {Talkative}
   */

  ,
  good_t_3: 'Talkative'

  /**
   * @variable {Amazing Performance}
   */

  ,
  good_t_4: 'Amazing Performance'

  /**
   * @variable {Attractive Voice}
   */

  ,
  good_t_5: 'Attractive Voice'

  /**
   * @variable {Good Body Figure}
   */

  ,
  good_t_6: 'Good Body Figure'

  /**
   * @variable {Young}
   */

  ,
  good_t_7: 'Young'

  /**
   * @variable {Mature}
   */

  ,
  good_t_8: 'Mature'

  /**
   * @variable {Fake Photos}
   */

  ,
  bad_t_1: 'Fake Photos'

  /**
   * @variable {Bad Attitude/Behaviors}
   */

  ,
  bad_t_2: 'Bad Attitude/Behaviors'

  /**
   * @variable {Poor Languages}
   */

  ,
  bad_t_3: 'Poor Languages'

  /**
   * @variable {Glitches(Black Screen/etc)}
   */

  ,
  bad_t_4: 'Glitches(Black Screen/etc)'

  /**
   * @variable {Bad conditions(noisy/blurred)}
   */

  ,
  bad_t_5: 'Bad conditions(noisy/blurred)'

  /**
   * @variable {Others}
   */

  ,
  bad_t_6: 'Others'

  /**
   * @variable {The picture you just uploaded does not meet our standards, please try other pictures.}
   */

  ,
  picisye: 'The picture you just uploaded does not meet our standards, please try other pictures.'

  /**
   * 语言不支持
   * @variable {Language does not support}
   */

  ,
  languagenosup: 'Language does not support'

  /**
   * @variable {E-mail format is wrong.}
   */

  ,
  error_email: 'E-mail format is wrong.'

  /**
   * @variable {Please enter password again.(6 – 12 Characters)}
   */

  ,
  error_password: 'Please enter password again.(6 – 12 Characters)'


  /**
   * @variable {Please enter your Nickname.(6 – 12 Characters)}
   */

  ,
  error_nickname: 'Please enter your Nickname.(6 – 12 Characters)'


  /**
   * @variable {Please upload a pic as your avatar}
   */

  ,
  error_noavatar: 'Please upload a pic as your avatar'

  /**
   * @variable {Time to spice things up %s Let's have fun %s}
   */

  ,
  def_mood: 'Time to spice things up %s Let\'s have fun %s'

  /**
   * @variable {This call will end in %d seconds Please recharge as early as you can}
   */

  ,
  hunt_hint: 'This call will end in %d seconds Please recharge as early as you can'

  /**
   * @variable {Wanna see me again ?Just call me baby!}
   */

  ,
  hunt_end_hint: 'Wanna see me again ?Just call me baby!'

  /**
   * @variable {The user is blocked by you.}
   */

  ,
  e_already_black: 'The user is blocked by you.'

  /**
   * @variable {Reach the maximum number of photo albums!}
   */

  ,
  e_max_photo: 'Reach the maximum number of photo albums!'

  /**
   * @variable {Your application is received and in review.}
   */

  ,
  e_already_apply: 'Your application is received and in review.'

  /**
   * @variable {Email has been registered, please jump to login}
   */

  ,
  e_email_exists: 'Email has been registered, please jump to login'

  /**
   * @variable {Account name does not exist!}
   */

  ,
  e_name_not_exists: 'Account name does not exist!'

  /**
   * @variable {You enter the password is incorrect.}
   */

  ,
  e_pwd: 'You enter the password is incorrect.'

  /**
   * @variable {Failed to recharge.}
   */

  ,
  e_fail_recharge: 'Failed to recharge.'

  /**
   * @variable {This device is blocked.}
   */

  ,
  e_block: 'This device is blocked.'

  /**
   * @variable {It seems that you've got blocked by the host.}
   */

  ,
  e_been_black: 'It seems that you\'ve got blocked by the host.'

  /**
   * @variable {The user is blocked by you.}
   */

  ,
  e_block_by_you: 'The user is blocked by you.'

  /**
   * @variable {Only female users can apply for the host!}
   */

  ,
  e_male_no_anchor: 'Only female users can apply for the host!'

  /**
   * @variable {You haven't followed the anchor yet.}
   */

  ,
  e_not_follow: 'You haven\'t followed the anchor yet.'

  /**
   * @variable {You have followed the anchor already.}
   */

  ,
  e_already_follow: 'You have followed the anchor already.'

  /**
   * @variable {Reach the maximum number of accounts for the equipment.}
   */

  ,
  e_max_account: 'Reach the maximum number of accounts for the equipment.'



  /**
   * @variable {Are you sure to delete your account?}
   */

  ,
  w_delete_act: 'Are you sure to delete your account?'


  /**
   * @variable {Your positive comment will encourage us to do better in the future!}
   */

  ,
  w_star: 'Your positive comment will encourage us to do better in the future!'




  /**
   * 分享地址
   * @variable {https://papayachat.onelink.me/FrtH?pid:User_invite&af_android_url:https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.lzlz.qifei&af_web_dp:https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.lzlz.qifei&is_retargeting:true}
   */

  ,
  url_share: 'https://papayachat.onelink.me/FrtH?pid:User_invite&af_android_url:https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.lzlz.qifei&af_web_dp:https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.lzlz.qifei&is_retargeting:true'

  /**
   * 分享失败
   * @variable {Messenger have not been installed.}
   */

  ,
  url_share_e_m: 'Messenger have not been installed.'

  /**
   * 分享失败
   * @variable {Your positive comment will encourage us to do better in the future!}
   */

  ,
  url_share_e_s: 'SnapChat have not been installed.'

  /**
   * 分享失败
   * @variable {WhatsApp have not been installed.}
   */

  ,
  url_share_e_w: 'WhatsApp have not been installed.'

  /**
   * 分享失败
   * @variable {facebook have not been installed.}
   */

  ,
  url_share_e_f: 'facebook have not been installed.'

  /**
   * @variable {Can not search for blank content}
   */

  ,
  e_search_blank: 'Can not search for blank content'

  /**
   * 提示当Boss暂时不能使用相机
   * @variable {You can't use camera when you are the boss.}
   */

  ,
  t_cant_camera: 'You can\'t use camera when you are the boss.'

  /**
   * 一对多支持人被带走私聊
   * @variable {The host is engaged in a private call. Please come back later}
   */

  ,
  e_live_host_in_private: 'The host is engaged in a private call. Please come back later'

  /**
   * 一对多支持人关播、未开播
   * @variable {The host is offline. Go have fun with other online hosts}
   */

  ,
  e_live_host_offline: 'The host is offline. Go have fun with other online hosts'

  /**
   * 一对多进入房间的公告
   * @variable {Welcome to live show. Please do not post abusive, violent and other similar info. For your info security, please do not share your personal info. Offenders may be silenced or even banned...}
   */

  ,
  t_video_room: 'Welcome to live show. Please do not post abusive, violent and other similar info. For your info security, please do not share your personal info. Offenders may be silenced or even banned...'

  /**
   * 一对多被禁言
   * @variable {You have been silenced.}
   */

  ,
  e_video_mute: 'You have been silenced.'

  /**
   * 一对多被取消禁言
   * @variable {You has been unmuted.}
   */

  ,
  e_video_unmute: 'You has been unmuted.'

  /**
   * 直播间提示
   * @variable {Say hi to the broadcaster}
   */

  ,
  video_hint_say_hi: 'Say hi to the broadcaster'

  /**
   * 直播间提示
   * @variable {Like her? Send a gift!}
   */

  ,
  video_hint_gift: 'Like her? Send a gift!'

  /**
   * 直播间提示
   * @variable {Follow her and don’t miss out the fun!}
   */

  ,
  video_hint_follow: 'Follow her and don’t miss out the fun!'

  /**
   * @variable {Private video chat}
   */

  ,
  video_private: 'Private video chat'

  /**
   * @variable {%d minutes for free, afterwards %d coins/min}
   */

  ,
  video_private_price: '%d minutes for free, afterwards %d coins/min'

  /**
   * @variable {Each private message cost 2 coins. Become SVIP to send messages for free.}
   */

  ,
  become_vip: 'Each private message cost 2 coins. Become SVIP to send messages for free.'

  /**
   * sse断开重连时吐司
   * @variable {Reconnecting, please try again later.}
   */

  ,
  e_sse_disconnect: 'Reconnecting, please try again later.'

  /**
   * @variable {Continue means you agree with our }
   */

  ,
  terms_desc: 'Continue means you agree with our '

  /**
   * @variable {Upload failed, please try again}
   */

  ,
  upfileFailed: 'Upload failed, please try again'

  /**
   * @variable {Voice transmission requires recording permission}
   */

  ,
  voice_permission: 'Voice transmission requires recording permission'

  /**
   * @variable {This function requires the camera and read and write permissions}
   */

  ,
  album_lbl: 'This function requires the camera and read and write permissions'

  /**
   * @variable {Oops, we don't support your region}
   */

  ,
  not_support: 'Oops, we don\'t support your region'

  /**
   * @variable {Recording and camera permission required to call host.}
   */

  ,
  perm_video_call: 'Recording and camera permission required to call host.'

  /**
   * @variable {Recording and camera permission required to be a boss.}
   */

  ,
  perm_video_boss: 'Recording and camera permission required to be a boss.'

  /**
   * @variable {You are already an SVIP member}
   */

  ,
  tips_already_sv: 'You are already an SVIP member'

  /**
   * @variable {Membership expired}
   */

  ,
  tips_sv_out: "Membership expired",

  tips_moment_hi: "Hi",
  tips_greet_successfully: "Greeted her successfully",
  tips_replied_succeed: "Replied  successfully",

  error_role_not_support: "You can't login as host in this app.",

  after_kicked_out: "Logged in on other device, please try again.",

  relogin_failed: "Information has expired. Please login again",

  e_voice_muted_boss: "You have been muted",

  e_anchor_close_private: "The host turned off private call.",

  e_block_in_chat: "You have been blocked by other user or she is in your blacklist.",

  /**
   * 断网状态
   */
  e_no_network: 'No Network',

  e_comment_has_been_deleted: "The Comment has been deleted",
  e_moment_has_been_deleted: "The Post has been deleted",
  e_illegal_as_anchor: "You can not log in user account with host information.",
  e_error_host_id:"Wrong host ID",
  e_error_anchor_id:"Wrong account ID",
  e_host_took:"The host is not available now."


}



// WEBPACK FOOTER //
// ./src/utils/Tips.js